/**
 * Split an app route string into pathname, search, and hash segments.
 * Query strings stay on the URL for pushState but are excluded from pathname routing.
 */
export function parseRoutePath(path, fallbackPathname = '/') {
  if (path.startsWith('#')) {
    return {
      pathname: fallbackPathname,
      search: '',
      hash: path
    };
  }

  const hashIndex = path.indexOf('#');
  const hash = hashIndex === -1 ? '' : path.slice(hashIndex);
  const withoutHash = hashIndex === -1 ? path : path.slice(0, hashIndex);

  const queryIndex = withoutHash.indexOf('?');
  const pathname = (queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex)) || '/';
  const search = queryIndex === -1 ? '' : withoutHash.slice(queryIndex);

  return { pathname, search, hash };
}
